<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>{{ productInfo.Goods_Name }}</span>
        <q-badge color="red" text-color="white" :label="productInfo.Goods_Code" align="top"/>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <apexchart
          v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
          :options="buyLastPriceChartOptions"
          height="300"
          :series="buyLastPriceChartSeries"></apexchart>
      <apexchart
          v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
          :options="buyDayPriceChartOptions"
          height="300"
          :series="buyDayPriceChartSeries"></apexchart>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ProductPriceTraceList",
  props: {
    productInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      items: [],
      buyLastPriceChartOptions: {
        chart: {
          id: 'buyLastPrice',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'آخرین خرید',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            show: false,
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
        yaxis: {
          labels: {
            show: false,
            formatter: function (val) {
              return val ? val.toLocaleString() : 0;
            }
          }
        },
        dataLabels: {
          formatter: function (val) {
            return val ? val.toLocaleString() : 0;
          }
        }
      },
      buyLastPriceChartSeries: [{
        name: 'آخرین خرید',
        data: []
      }],
      buyDayPriceChartOptions: {
        chart: {
          id: 'buyLastPrice',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'خرید روز',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            show: false,
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
        yaxis: {
          labels: {
            show: false,
            formatter: function (val) {
              return val ? val.toLocaleString() : 0;
            }
          }
        },
        dataLabels: {
          formatter: function (val) {
            return val ? val.toLocaleString() : 0;
          }
        }
      },
      buyDayPriceChartSeries: [{
        name: 'خرید روز',
        data: []
      }],
    }
  },
  methods: {
    ...mapActions({
      getData: 'Products/getProductPriceTraceList'
    })
  },
  created() {
    this.getData(this.productInfo.Goods_ID).then((res) => {
      this.items = res
      this.buyLastPriceChartOptions = {
        xaxis: {
          categories: res.filter(item => item.BuyLast_Price).map(item => item.BuyLast_Date)
        }
      }
      this.buyLastPriceChartSeries = [{
        data: res.filter(item => item.BuyLast_Price).map(item => item.BuyLast_Price)
      }]

      this.buyDayPriceChartOptions = {
        xaxis: {
          categories: res.filter(item => item.BuyDay_Price).map(item => item.BuyDay_Date)
        }
      }
      this.buyDayPriceChartSeries = [{
        data: res.filter(item => item.BuyDay_Price).map(item => item.BuyDay_Price)
      }]
    })
  }
}
</script>

<style scoped>

</style>